/**
 * Safely evaluates a formula expression using `new Function`, which runs in
 * global scope. Formula strings have access to window globals (including all
 * CoreFormula functions registered by global.js at startup: SUM, IF, AVG,
 * getInputFormulaValue, etc.) but do NOT have access to the calling module's
 * local variables or imported bindings.
 *
 * This replaces bare `eval()`, which exposed the entire local closure scope
 * to formula strings — a potential data leakage vector.
 *
 * @param {string} code - Formula expression to evaluate (e.g. "SUM({{field1}}, {{field2}})")
 * @param {Object} scope - Additional named variables to expose beyond window globals
 * @returns {*} Result of evaluation, or undefined if evaluation fails
 */
// eslint-disable-next-line no-new-func
export function safeEval(code, scope = {}) {
  try {
    const fn = new Function(...Object.keys(scope), `"use strict"; return (${code});`);
    return fn(...Object.values(scope));
  } catch (e) {
    return undefined;
  }
}
